// @flow

import React from 'react'
import Appear from './Appear'
import { markdown } from 'markdown'
import Communications2 from './Communications2'

type Props = {
  title: string,
  text: string,
  text2: string,
}

const Icon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="89.762" height="101.861"><g fill="none" stroke="#a5f37c" strokeWidth="4" data-name="Grupo 124"><path strokeLinecap="square" strokeMiterlimit="10" d="M59.354 29.375H18.812" data-name="Línea 5"/><path strokeLinecap="square" strokeMiterlimit="10" d="M59.354 44.885H18.812" data-name="Línea 6"/><path strokeLinecap="square" strokeMiterlimit="10" d="M59.354 60.386H18.812" data-name="Línea 7"/><path strokeLinecap="round" strokeLinejoin="round" d="M71.066 2H18.831L2.016 19.063v64.419a4.468 4.468 0 004.6 4.289h64.447a4.468 4.468 0 004.6-4.289V6.288A4.468 4.468 0 0071.066 2z" data-name="Trazado 27"/><path strokeLinecap="round" strokeLinejoin="round" d="M14.207 19.063a4.467 4.467 0 004.6-4.287V2L1.992 19.063z" data-name="Trazado 28"/><path strokeLinecap="round" strokeLinejoin="round" d="M83.157 14.09h-7.486v73.68H14.107v7.8a4.468 4.468 0 004.6 4.289h64.45a4.468 4.468 0 004.6-4.289V18.375a4.467 4.467 0 00-4.6-4.285z" data-name="Trazado 29"/></g></svg>
)

const Communications3 = ({ title, text, text2 }: Props) => {
  return (
    <>
      <Communications2 text={title} />
      <Appear>
        <div className="p-6 my-6 bg-white md:p-8 md:my-8">
          {text &&
            <div className="mb-6 text-base leading-tight text-left md:text-lg md:mb-8 text-green markdownNoMargin" dangerouslySetInnerHTML={{ __html: markdown.toHTML(text) }} />
          }
          <Appear>
            <div className="flex flex-col items-center justify-start md:flex-row">
              <div key="image">
                <Icon />
              </div>
              {text2 && 
                <div
                  key="text"
                  className="mt-4 text-base font-light md:text-lg md:mt-0 md:ml-8 text-green" 
                  dangerouslySetInnerHTML={{ __html: markdown.toHTML(text2) }}
                />
              }
            </div>
          </Appear>
        </div>
      </Appear>
    </>
  )
}

export default Communications3